<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center">
      <b-col md="7" class="mt-3">
        <b-card-group>
          <b-card id="auftrag1" ref="el">
            <b-row slot="header">
              <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
                Aufgabe von: <strong>{{auftraggeberComp}}</strong>
              </b-col>
              <b-col></b-col>
              <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
                <strong style="float: right">{{formateDate(aufgabe.datum)}}</strong>
              </b-col>
            </b-row>
            <b-row style="border-bottom: 1px solid #ccc!important;">
              <b-col sm="6">
                <b-form-group
                    label="Aufgabensteller:"
                    label-for="auftraggeber"
                >
                  <b-form-input
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                      disabled
                      id="auftraggeber"
                      type="text"
                      :placeholder="sachbearbeiterComp"
                      v-model="sachbearbeiterComp"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                    label="Zieltermin an/bis:"
                    label-for="date"
                >
                  <datetime
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      :disabled="true"
                      v-model="aufgabe.ziel_datum"
                      input-class="form-control"
                      input-style="color: black;"
                      input-id="date"
                      :aria-placeholder="formateDate(aufgabe.ziel_datum)"
                      :phrases="datetimeConfig.phrases"
                      :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                      :min-datetime="datetimeConfig.minTime"></datetime>

                </b-form-group>
              </b-col>
            </b-row>
            <b-row style="border-bottom: 1px solid #ccc!important;">
            </b-row>
            <b-row class="mt-3">
              <b-col sm="2">
                <p class="p-center">Aufgabentitel:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    class="bold-text"
                    :disabled="true"
                    type="text"
                    v-model="aufgabe.gi_auf_ext"
                    :placeholder="aufgabe.gi_auf_ext"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row v-if="aufgabe.gi_match !== ''">
              <b-col sm="2">
                <p class="p-center">Suchbegriff:</p>
              </b-col>
              <b-col>
                <b-form-input
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                    disabled
                    type="text"
                    v-model="aufgabe.gi_match"
                    :placeholder="aufgabe.gi_match"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row v-if="hasContact">
              <b-col sm="2">
                <p class="p-center">Für Rückfragen:</p>
              </b-col>
              <b-col>
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    disabled
                    type="text"
                    v-model="contact"
                    :placeholder="contact"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="2"></b-col>
              <b-col>
                <b-form-textarea id="info-box" ref="infoBox"
                                 class="text-black"
                                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                 :placeholder="aufgabe.gi_memo"
                                 :rows="8"
                                 :max-rows="maxrows"
                                 wrap="hard"
                                 :disabled="true"
                                 v-model="aufgabe.gi_memo"

                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3 pt-3" style="border-top: 2px solid #ccc!important;">
              <b-col sm="6">
                <b-form-group
                    label="Aufgabennehmer:"
                >
                  <b-form-input
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                      disabled
                      type="text"
                      :placeholder="anhemerComp"
                      v-model="anhemerComp"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                    label="Annahmedatum:"
                >
                  <datetime
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      :disabled="true"
                      v-model="aufgabe.quittung_datum"
                      input-class="form-control"
                      input-style="color: black;"
                      input-id="date"
                      :aria-placeholder="formateDate(aufgabe.quittung_datum)"
                      :phrases="datetimeConfig.phrases"
                      :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                      :min-datetime="datetimeConfig.minTime"></datetime>

                </b-form-group>
              </b-col>
            </b-row>

          </b-card>
        </b-card-group>
        <b-card class="mt-2" v-if="showTodos">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Aufgabenverteilung:</strong>
            </b-col>
            <b-col></b-col>
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              <b-button variant="success" :disabled="!forMe" style="float: right" class="btn-pill font-sm" @click="onSelectUser">
                Aufteilen
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped bordered hover responsive :items="todos"
                       :fields="fields">
                <template v-slot:cell(is_finished)="row">
                  <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
                  <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="!row.item.is_finished"></book-open-page-variant-icon>
                  <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-else></check-bold-icon>
                </template>
                <template v-slot:cell(delete)="row">
                  <delete-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: red; cursor: pointer" @click="onTodoDelete(row.item.id)"></delete-icon>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="5" class="mt-3">
        <b-card>
          <b-row style="gap: 10px">
            <b-button variant="success" v-if="hasTodo" class="btn-pill font-lg" v-on:click="onFinishTodo">
              Fertigstellen
            </b-button>
            <b-button variant="success" v-if="forMe" class="btn-pill font-lg" v-on:click="showFinishTask">
              Fertigstellen
            </b-button>
            <b-button variant="success" v-if="forMe" class="btn-pill font-lg" v-on:click="redirectCreate">
              An Bauhof senden
            </b-button>
            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
              Zurück
            </b-button>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            Anhänge
          </div>
          <b-row>
            <b-col>
              <b-list-group>
                <b-list-group-item
                    button
                    class="d-flex justify-content-between align-items-center"
                    v-for="item in attachments"
                    v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                  {{item.file_name}}
                  <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                    {{formatBytes(item.file_size)}}
                  </b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="rooms.length">
          <div slot="header">
            Chats
          </div>
          <b-row style="gap: 10px; margin-top: -12px; margin-bottom: -12px">
            <template v-for="(room, roomId, index) in rooms">
              <task-messaging-button :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben' : 'Auftraggeber'" :new-messages="room.room.unreadCount" @open-chat="showChat = roomId; room.room.unreadCount = 0;"/>
            </template>
          </b-row>
        </b-card>
        <b-card v-if="aufgabe.lat !== 0.0 && aufgabe.lon !== 0.0">
          <div slot="header">
            Position
          </div>
          <b-row style="margin-bottom: 0">
            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                   ref="map_container">
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="aufgabe.notiz_annahme !== null && aufgabe.quittung === 'True'">
          <div slot="header">
            Annahme-Nachricht
          </div>
          <b-row>
            <b-col>
              <b-form-textarea
                  class="text-black"
                  :placeholder="aufgabe.notiz_annahme"
                  rows="6"
                  max-rows="40"
                  wrap="hard"
                  :disabled="true"
                  v-model="aufgabe.notiz_annahme"

              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

    </b-row>
    <beautiful-chat
        v-if="room === null && hasChat"
        :participants="participants"
        :onMessageWasSent="onMessageWasSent"
        :messageList="messageList"
        :newMessagesCount="newMessagesCount"
        :isOpen="isChatOpen"
        :close="closeChat"
        :open="openChat"
        :showEmoji="false"
        :showFile="true"
        :showTypingIndicator="showTypingIndicator"
        :showLauncher="true"
        :showCloseButton="true"
        :colors="colors"
        :alwaysScrollToBottom="alwaysScrollToBottom"
        :messageStyling="messageStyling"
        :disable-user-input="disableChat"
        :placeholder="messagePlaceholder"
        @file_clicked="onFileClicked"
    >
      <template v-slot:header>
        <div class="sc-header--title ">
          Nachrichten:
        </div>
      </template>
      <template v-slot:user-avatar="{ message, user }">
        <div>
        </div>
      </template>
      <template v-slot:text-message-body="{ message }">
        <p style='font-weight: bold; margin-bottom: 3px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; margin-left: -12px'>
          {{message.data.meta_name}}:
        </p>
        <p style="margin-left: -12px; margin-bottom: 8px; white-space: pre-wrap;">{{message.data.text}}</p>
        <p style="text-align: right; font-weight: lighter; font-size: 12px; margin-bottom: 0px; margin-top: 8px; margin-right: -12px">
          {{message.data.meta}}
        </p>
      </template>
      <template v-slot:text-message-toolbox="{ message }">
      </template>
    </beautiful-chat>
    <b-modal size="sm" v-model="showFinish" id="modal-center" centered title="Aufgabe fertigstellen"
             body-class="my-body" @ok="finishTask">
      <b-row style="padding: 12px;">
        <b-col>
          <form>
            <b-form-group
                label="Fertigstellungsnachricht:"
            >
              <b-form-textarea
                  class="text-black"
                  rows="6"
                  max-rows="40"
                  wrap="hard"
                  v-model="finishMessage"
                  style="min-height: 150px"

              ></b-form-textarea>
            </b-form-group>
          </form>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel()">
          Abbrechen
        </b-button>
        <b-button size="md" variant="success" @click="ok()">
          Fertigstellen
        </b-button>
      </template>
    </b-modal>
    <b-modal size="sm" v-model="showSelectUser" centered title="Mitarbeiter auswählen"
             body-class="my-body" @ok="userSelected">
      <b-row style="padding: 12px;">
        <b-col>
          <v-jstree ref="js_tree" :allow-transition="false" style="flex: 1 0"
                    class="my-tree" :data="possibleUser"
                    @item-click="onItemClicked"
                    show-checkbox></v-jstree>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel()">
          Abbrechen
        </b-button>
        <b-button size="md" variant="success" :disabled="selectedUser === null" @click="ok()">
          Auswählen
        </b-button>
      </template>
    </b-modal>
    <b-modal size="sm" v-model="showCreateTodo" centered title="Aufgabe personalisieren"
             body-class="my-body" @ok="onCreateTodo">
      <b-row  style="padding-left: 12px; padding-right: 12px; padding-top: 12px">
        <b-col>
          <b-form-group
              label="Zieltermin:"
              label-for="date"
          >
            <datetime
                style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                v-model="new_time"
                input-class="form-control"
                input-style="color: black;"
                input-id="date"
                :aria-placeholder="formateDate(new_time)"
                :phrases="datetimeConfig.phrases"
                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                :min-datetime="datetimeConfig.minTime"></datetime>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="padding-left: 12px; padding-right: 12px;">
        <b-col>
          <b-form-group
              label="Aufgabennachricht:"
              label-for="an"
          >
            <b-form-textarea id="an"
                             class="text-black"
                             style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                             :placeholder="new_message"
                             :rows="8"
                             :max-rows="maxrows"
                             wrap="hard"
                             v-model="new_message"

            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="padding-left: 12px; padding-right: 12px; padding-bottom: 12px">
        <b-col>
          <b-form-group
              label="Aufgabenabschluss:"
              label-for="an"
          >
            <b-form-select :options="d_select" :plain="true"
                           v-model="aufgabe.aufgabe"
                           class="mb-2 text-black"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel()">
          Abbrechen
        </b-button>
        <b-button size="md" variant="success" @click="ok()">
          Speichern
        </b-button>
      </template>
    </b-modal>
    <template v-for="(room, roomId, index) in rooms">
      <task-messaging @chat-active="activateChat" :key="roomId" :room="room.room" :is-second="index !== 0" v-if="showChat === roomId && room.room != null" :last-online="room.lastOnline" @close-chat="showChat = null" @show-group="room.showChatGroup = true" @show-invite="room.showInvite = true" @user-added="addRoomUser" @leave-room="leaveRoom"/>
      <!--task-messaging-footer :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben Chat' : 'Auftraggeber Chat'" :is-second="index !== 0" :new-messages="room.room.unreadCount" v-if="room.room !== null && showChat !== roomId" @open-chat="showChat = roomId; room.room.unreadCount = 0;"></task-messaging-footer-->
      <task-messaging-users v-if="room.room !== null" :show-group="room.showChatGroup" :users="room.room.users" @hide-group="room.showChatGroup = false"></task-messaging-users>
      <task-messaging-invite v-if="room.room != null" @hidden="room.showInvite = false" :show-invite="room.showInvite" :room="room.room" @hide-invite="room.showInvite = false" @invite-success="(userid) => {room.room.users.push({_id: userid})}"></task-messaging-invite>
    </template>
  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {arrayContains, Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
import {
  decryptAES,
  decryptFile,
  decryptMessages, decryptTodos,
  encryptAES,
  encryptFile,
  encryptMultipleAES
} from "../../../shared/crypto";
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import VJstree from 'vue-jstree'
import TaskMessaging from "../../messaging/task_messaging.vue"
import TaskMessagingFooter from "@/views/messaging/task_messaging_footer.vue";
import TaskMessagingUsers from "@/views/messaging/task_messaging_user.vue";
import TaskMessagingInvite from "@/views/messaging/task_messaging_invite.vue";
import TaskMessagingButton from "@/views/messaging/task_messaging_button.vue";

import { doc, onSnapshot } from "firebase/firestore";
import {firestoreDb} from "@/shared/firebase";
import {listenMessageCounter, PARTICIPANT_PATH} from "@/shared/firebase/database";


export default {
  name: "aufgaben_offen",
  components: {
    AccountMultiplePlusIcon, BookOpenPageVariantIcon,
    CheckBoldIcon, VJstree,DeleteIcon,
    TaskMessaging,
    TaskMessagingFooter,
    TaskMessagingUsers,
    TaskMessagingInvite,
    TaskMessagingButton
  },
  props:{
    onFileClicked: {
      type: Function,
      default: undefined
    },
    onFileOk: {
      type: Function,
      default: undefined
    },
    onAttachment: {
      type: Function,
      default: undefined
    },
    responseError: {
      type: Function,
      default: undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  computed: {
    auftraggeberComp() {
      if (this.aufgabe.auftraggeber === "mm" && this.aufgabe.modul === "mm") {
        return "Mängelmelder";
      }
      let res = JSON.parse(sessionStorage.getItem(this.aufgabe.auftraggeber));
      if (res !== null) {
        return res.first_name + " " + res.surname;
      }
      if (this.aufgabe.auftraggeber in this.allGroups) {
        return  this.allGroups[this.aufgabe.auftraggeber];
      }
      return this.aufgabe.auftraggeber;
    },
    sachbearbeiterComp() {
      let res = JSON.parse(sessionStorage.getItem(this.aufgabe.sachbearbeiter));
      if (res !== null) {
        return res.first_name + " " + res.surname;
      }
      return this.aufgabe.sachbearbeiter;
    },
    anhemerComp() {
      let res = JSON.parse(sessionStorage.getItem(this.aufgabe.a_nehmer_user));
      if (res !== null) {
        return res.first_name + " " + res.surname;
      }
      return this.aufgabe.a_nehmer_user;
    }
  },
  data: () => {
    return {
      showChatGroup: false,
      showChat: null,
      showInvite: false,
      room: null,
      rooms: {},

      aufgabe: {
        id: "",
        auftraggeber: "",
        sachbearbeiter: "",
        a_nehmer: "",
        gi_match: "",
        gi_memo: "",
        datum: null,
        ziel: "",
        ziel_datum: null,
        quittung_datum: "",
        gi_auf_ext: "",
        modul: "",
        lat: 0.0,
        lon: 0.0,
        custom_properties: ""
      },
      attachments: [],
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      maxrows: 40,
      userId: "",
      interval: null,

      listeners: {},
      lastOnline: null,
      // chat specific
      hasChat: false,
      disableChat: false,
      messagePlaceholder: "Nachricht schreiben...",
      participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: false, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)

      finishMessageMmDefault: "Ihre Kommune meldet, dass der von Ihnen gemeldete Mangel nun behoben ist.\nVielen Dank für Ihre Mithilfe.",
      finishMessage: "",
      showFinish: false,


      groups: [],
      hasContact: false,
      contact: "",
      allGroups: {},
      isMe: false,
      canInteract: true,
      fromMe: false,
      forMe: false,
      possibleUser: [],
      todos: [],
      fields: [
        {key: 'is_finished', label: 'Status'},
        {key: 'user_id', label:"Nutzer", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = JSON.parse(sessionStorage.getItem(item.user_id));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }},
        {key: 'till', label:"Termin", formatter: 'dateToString'},
        {key: 'message', label: "Aufgabenbeschreibung", formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = item.message;
            let n = 40;
            return (res.length > n) ? res.slice(0, n-1) + '...' : res;
          }},
      ],
      showSelectUser: false,
      selectedUser: null,

      showCreateTodo: false,
      new_time: null,
      new_message: "",
      d_select: [{text: "manuell", value: "0"}, {text: "automatisch", value: "1"}],
      hasTodo: false,
      showTodos: false,
    }
  },
  beforeDestroy: function () {
    for (const property in this.listeners) {
      this.listeners[property].forEach(listener => listener())
      this.listeners[property] = []
    }
    window.clearInterval(this.interval);
  },
  methods: {
    activateChat(roomId) {
      this.rooms[roomId].room.is_active = true;
      if (this.listeners[roomId] === null || this.listeners[roomId] === undefined || this.listeners[roomId].length === 0) {
        this.startListener(roomId, this.userId)
      }
    },
    onFinishTodo() {
      let todoId = null;
      for (let i = 0; i < this.todos.length; i++) {
        let cur = this.todos[i]
        if (cur.user_id === this.$cookies.get("ps_user_id") && cur.is_finished === false) {
          todoId = cur.id;
          break;
        }
      }
      if (todoId !== null) {
        let payload = {
          todo_id: todoId,
        }
        this.showLoader();
        this.$http.post(
            Server_URL + '/auftragsbuch/data/todo/finish/' + this.aufgabe.id, payload
        ).then(this.responseOkReload, this.responseError)
      }
    },
    onTodoDelete(id) {
      let payload ={
        todo_id: id,
      };
      this.$http.post(
          Server_URL + '/auftragsbuch/data/todo/delete/' + this.aufgabe.id, payload
      ).then(this.responseErrorTrap, this.responseError)
      let index = -1;
      for (let i = 0; i < this.todos.length; i++) {
        if (this.todos[i].id === id) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.todos.splice(index, 1);
      }
    },
    onItemClicked(node, item, e) {
      this.selectedUser = item.id;
    },
    onSelectUser() {
      this.selectedUser = null;
      this.possibleUser = this.setNames(this.possibleUser);
      this.showSelectUser = true;
    },
    setNames(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user') {
          let res = JSON.parse(sessionStorage.getItem(cur.id));
          if (res !== null) {
            org[i].text = res.first_name + " " + res.surname;
            org[i].selected = false;
            org[i].disabled = this.aufgabe.a_nehmer_user === cur.id || this.aufgabe.sachbearbeiter === cur.id || this.idInTodos(cur.id);
          }
        } else {
          org[i].disabled = true;
        }
        if (cur.children !== null && cur.children.length > 0) {
          org[i].children = this.setNames(cur.children);
        }
      }
      return org
    },
    idInTodos(id) {
      for (let i = 0; i < this.todos.length; i++) {
        if (this.todos[i].user_id === id) {
          return true
        }
      }
      return false;
    },
    userSelected() {
      this.showSelectUser = false;
      this.new_time = this.aufgabe.ziel_datum;
      this.new_message = this.aufgabe.gi_memo;
      this.showCreateTodo = true;
    },
    onCreateTodo() {
      this.showLoader();
      let payload ={
        gi_memo: this.new_message,
        ziel_datum: this.new_time,
        user_id: this.selectedUser,
        close_automatic: this.aufgabe.aufgabe === "1",
      };
      if (sessionStorage.getItem("aes") !== null) {
        this.showLoader();
        encryptMultipleAES(sessionStorage.getItem("aes"), [payload.gi_memo]).then(res => {
          payload.gi_memo = res[0];
          this.$http.post(
              Server_URL + '/auftragsbuch/data/todo/create/'+ this.aufgabe.id, payload
          ).then(this.responseOkNewTodo, this.responseError)
          this.showCreateTodo = false;
        }).catch(res => {
        })
      }
    },
    showFinishTask() {
      if (this.aufgabe.modul === 'mm') {
        this.finishMessage = this.finishMessageMmDefault;
      }
      this.showFinish = true;
    },
    formateDate(date) {
      if (date === null) {
        return ""
      }
      let event = new Date(date.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    responseOkFetch(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.userId = response.body.session.id;
        let data = response.body.data;
        this.computeShowTodos();
        if (sessionStorage.getItem("aes") !== null) {
          this.decryptData(data.data.gi_memo, data.data.notiz_annahme, data.todos).then(res => {
            data.data.gi_memo = res[0];
            data.data.notiz_annahme = res[1];
            data.todos = res[2];
            this.setData(data);
          }).catch(e => {
            console.log(e)
            this.setData(data);
          });
        } else {
          this.setData(data);
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    computeShowTodos() {
      let suiteModules = sessionStorage.getItem("suite_modules");
      if (suiteModules !== null && suiteModules !== '') {
        suiteModules = JSON.parse(suiteModules);
        if (arrayContains(suiteModules, 18)) {
          this.showTodos = true;
        }
      }
      },
    responseOkNewTodo(response) {
      if (response.status === 200) {
        let todo = response.body;
        if (sessionStorage.getItem("aes") !== null) {
          this.decryptData(todo.message, null, null).then(res => {
            todo.message = res[0];
            this.todos.push(todo);
            this.hideLoader();
          }).catch(e => {
            console.log(e)
            this.todos.push(todo);
            this.hideLoader();
          });
        } else {
          this.todos.push(todo);
          this.hideLoader();
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptData(message, annahme, todos) {
      try {
        todos = await decryptTodos(sessionStorage.getItem("aes"), todos)
      } catch (e) {
      }
      try {
        if (message !== null && message !== "") {
          message = await decryptAES(sessionStorage.getItem("aes"), message);
        }
      } catch (e) {
      }
      try {
        if (annahme !== null && annahme !== "" ) {
          annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
        }
      } catch (e) {
      }
      return [message, annahme, todos]
    },
    setData(data) {
      this.aufgabe = data.data;
      this.allGroups = data.all_groups;
      this.hideLoader();
      this.groups = data.groups;
      this.fromMe = data.from_me;
      this.forMe = data.for_me;
      this.todos = data.todos;
      this.possibleUser = data.possible_users;
      if (this.forMe) {
        this.fields.push({key: 'delete', label: ""})
      }
      for (let i = 0; i < this.todos.length; i++) {
        let cur = this.todos[i];
        if (cur.user_id === this.$cookies.get("ps_user_id")) {
          if (cur.is_finished === false) {
            this.hasTodo = true;
          }
          this.aufgabe.gi_memo = cur.message;
          this.aufgabe.ziel_datum = cur.till;
          break;
        }
      }
      /*for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i].name === this.anfrage.receiving_group) {
          this.canInteract = true;
        }
        let res = JSON.parse(sessionStorage.getItem(this.groups[i].name));
        if (res !== null) {
          this.a_select.push({text: res.username, value: this.groups[i]});
        } else {
          this.a_select.push({text: this.groups[i].name, value: this.groups[i]});
        }
      }*/
      this.contact = "";
      if (this.aufgabe.modul === "mm") {
        let defectData = JSON.parse(this.aufgabe.custom_properties);
        let hasContact = defectData.name !== "" || defectData.email !== "" || defectData.phone_number !== "";
        if (hasContact) {
          if (defectData.name !== "") {
            this.contact += "Name: " + defectData.name + "\n"
          }
          if (defectData.email !== "") {
            this.contact += "Email: " + defectData.email + "\n"
          }
          if (defectData.phone_number !== "") {
            this.contact += "Tel: " + defectData.phone_number + "\n"
          }
        }
      }
      this.hasContact = this.contact !== "";
      this.isMe = this.$cookies.get("ps_user_id") === this.aufgabe.a_nehmer_user;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
      this.attachments = data.attachments;
      this.hasChat = data.has_chat;

      if (this.hasChat && data.chat_room.roomId === "" && data.chat_room_internal.roomId === "") {
        for (let i = 0; i < data.authors.length; i++) {
          let res = JSON.parse(sessionStorage.getItem(data.authors[i].id));
          if (res !== null) {
            data.authors[i].name = res.full_name;
          }
        }
        this.participants = data.authors;
        if (sessionStorage.getItem("aes") !== null) {
          decryptMessages(sessionStorage.getItem("aes"), data.messages).then(res => {
            this.messageList = res;
            if (this.messageList.length !== 0) {
              this.isChatOpen = true;
            }
            if (this.interval === null) {
              this.interval = setInterval(this.refresh, 2000);
            }
          }).catch(err => {

            this.messageList = data.messages;
            if (this.messageList.length !== 0) {
              this.isChatOpen = true;
            }
            if (this.interval === null) {
              this.interval = setInterval(this.refresh, 2000);
            }
          })
        } else {
          this.messageList = data.messages;
          if (this.messageList.length !== 0) {
            this.isChatOpen = true;
          }
          if (this.interval === null) {
            this.interval = setInterval(this.refresh, 2000);
          }
        }
      } else if (this.hasChat) {
        this.room = {};
        if (this.hasChat && data.chat_room.roomId !== "") {
          data.chat_room.unreadCount = 0;
          this.$set(this.rooms, data.chat_room.roomId,
              {
                room: data.chat_room,
                showChatGroup: false,
                showChat: false,
                showInvite: false,
                lastOnline: null,
              })
          this.listeners[data.chat_room.roomId] = [];
          //this.room = data.chat_room;
          if (this.rooms[data.chat_room.roomId].room.is_active
              && !this.rooms[data.chat_room.roomId].room.is_archived) {
            let found = false;
            for (let i = 0; i < this.rooms[data.chat_room.roomId].room.users.length; i++) {
              if (this.rooms[data.chat_room.roomId].room.users[i]._id === this.userId) {
                found = true;
                break;
              }
            }
            if (found) {
              this.startListener(data.chat_room.roomId, this.$cookies.get("ps_user_id"));
            }
            if (this.$route.query.open_chat === "task") {
              this.showChat = data.chat_room.roomId;
            }
          }
        }
        if (this.hasChat && data.chat_room_internal.roomId !== "") {
          data.chat_room_internal.unreadCount = 0;
          this.$set(this.rooms, data.chat_room_internal.roomId,
              {
                room: data.chat_room_internal,
                showChatGroup: false,
                showChat: false,
                showInvite: false,
                lastOnline: null,
              })
          this.listeners[data.chat_room_internal.roomId] = [];
          //this.room = data.chat_room;
          if (this.rooms[data.chat_room_internal.roomId].room.is_active
              && !this.rooms[data.chat_room_internal.roomId].room.is_archived) {
            let found = false;
            for (let i = 0; i < this.rooms[data.chat_room_internal.roomId].room.users.length; i++) {
              if (this.rooms[data.chat_room_internal.roomId].room.users[i]._id === this.userId) {
                found = true;
                break;
              }
            }
            if (found) {
              this.startListener(data.chat_room_internal.roomId, this.$cookies.get("ps_user_id"));
            }
            if (this.$route.query.open_chat === "int") {
              this.showChat = data.chat_room_internal.roomId;
            }
          }
        }
      }
    },
    addRoomUser(roomId, u) {
      let found = false;
      for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
        if (this.rooms[roomId].room.users[i]._id === u) {
          found = true;
          break;
        }
      }
      if (!found) {
        this.rooms[roomId].room.users.push({_id: u,  username: ""})
        if (this.userId === u) {
          this.startListener(roomId, u)
        }
      }
    },
    leaveRoom(roomId) {
      for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
        if (this.rooms[roomId].room.users[i]._id === this.userId) {
          this.rooms[roomId].room.users.splice(i, 1);
          break;
        }
      }
      this.listeners[roomId].forEach(listener => listener());
      this.listeners[roomId] = [];
    },
    startListener(roomId, userId) {
      if (userId === this.$cookies.get("ps_user_id")) {
        if (this.listeners[roomId]) {
          this.listeners[roomId].forEach(listener => listener());
        }
        this.listeners[roomId] = [];
        const unsub = listenMessageCounter(this.$cookies.get("ps_customer_number"),
            this.rooms[roomId].room.roomId,
            this.$cookies.get("ps_user_id"),
            (data) => {
              this.rooms[roomId].room.unreadCount = data.count_unread;
              this.rooms[roomId].lastOnline = data.last_active.toDate();
            });
        this.listeners[roomId].push(unsub)
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    back() {
      this.$router.go(-1);
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    onMessageWasSent(message) {
      // called when the user sends a message
      if (this.interval !== null) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (message.type === "text") {
        let body = {
          data_id: this.aufgabe.id,
          data_beleg_ex: this.aufgabe.gi_auf_ext,
          message: message.data.text,
        };
        if (this.messageList.length > 0) {
          body.create_date = this.messageList[this.messageList.length - 1].data.meta_date;
        }
        if (sessionStorage.getItem("aes") !== null) {
          encryptAES(sessionStorage.getItem("aes"), body.message).then(res => {
            body.plain_text = body.message;
            body.plain_name = JSON.parse(sessionStorage.getItem(this.userId)).full_name;
            body.message = res;
            this.$http.post(
                Server_URL + '/auftragsbuch/data/message', body
            ).then(this.onNewMessages, this.responseError)
          })
        } else {
          this.$http.post(
              Server_URL + '/auftragsbuch/data/message', body
          ).then(this.onNewMessages, this.responseError)
        }
      } else {
        if (sessionStorage.getItem("aes") !== null) {
          this.showLoader();
          const reader = new FileReader();
          reader.addEventListener('load', (event) => {
            let buf = new Uint8Array(event.target.result);
            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
              const b = new Blob([res], {type: message.data.file.type});
              let lastDate = "";
              if (this.messageList.length > 0) {
                lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
              }
              let formData = new FormData();
              formData.append('upload_file', b, message.data.file.name);
              this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                  +this.$route.params.id+"?plain_name=" + JSON.parse(sessionStorage.getItem(this.userId)).full_name + "&last_date=" + lastDate,
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
              ).then(this.onNewMessages, this.responseError)
            }).catch(err => {
              this.hideLoader();
            })
          });
          reader.readAsArrayBuffer(message.data.file);
        } else {
          let lastDate = "";
          if (this.messageList.length > 0) {
            lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
          }
          let formData = new FormData();
          formData.append('upload_file',message.data.file);
          this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
              +this.$route.params.id+"?plain_name=xxx"+"&last_date=" + lastDate,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
          ).then(this.onNewMessages, this.responseError)
        }
      }
    },
    onNewMessages(response) {
      if (response.status === 200) {
        if (response.body.authors !== undefined) {
          for (let i = 0; i < response.body.authors.length; i++) {
            let found = false;
            for (let j = 0; j < this.participants.length; j++) {
              if (this.participants[j].id === response.body.authors[i].id) {
                found = true;
                break
              }
            }
            if (!found) {
              let res = JSON.parse(sessionStorage.getItem(response.body.authors[i].id));
              if (res !== null) {
                response.body.authors[i].name = res.full_name;
              }
              this.participants.push(response.body.authors[i]);
            }
          }
        }
        if (sessionStorage.getItem("aes") !== null) {
          decryptMessages(sessionStorage.getItem("aes"), response.body.messages).then(res => {
            for (let i = 0; i < res.length; i++) {
              this.messageList.push(res[i]);
            }
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + res.length;
            if (this.interval === null) {
              this.interval = setInterval(this.refresh, 2000);
            }
          })
        } else {
          for (let i = 0; i < response.body.messages.length; i++) {
            this.messageList.push(response.body.messages[i]);
          }
          this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + response.body.messages.length;
          if (this.interval === null) {
            this.interval = setInterval(this.refresh, 2000);
          }
        }
        this.hideLoader();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    refresh() {
      let url = Server_URL + '/auftragsbuch/data/messages/' + this.aufgabe.id;
      if (this.messageList.length !== 0) {
        url += "?last_date=" + encodeURIComponent(this.messageList[this.messageList.length - 1].data.meta_date);
      }
      this.$http.get(
          url
      ).then(this.onNewMessages, this.responseErrorTrap)
    },
    responseErrorTrap(response) {
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
      }
    },
    finishTask() {
      this.showLoader();
      let payload ={
        finish_message: this.finishMessage,
        finish_message_plain: this.finishMessage,
      };
      if (sessionStorage.getItem("aes") !== null) {
        this.showLoader();
        encryptMultipleAES(sessionStorage.getItem("aes"), [payload.finish_message]).then(res => {
          payload.finish_message = res[0];
          this.$http.post(
              Server_URL + '/auftragsbuch/data/finish/'+ this.aufgabe.id, payload
          ).then(this.responseOkReload, this.responseError)
          this.showFinish = false;
        }).catch(res => {
        })
      } else {
        this.showLoader();
        this.$http.post(
            Server_URL + '/auftragsbuch/data/finish/'+ this.aufgabe.id, payload
        ).then(this.responseOkReload, this.responseError)
        this.showFinish = false;
      }
    },
    responseOkReload() {
      this.hideLoader();
      this.$router.go();
    },
    redirectCreate() {
      this.$router.push("/create?data_id=" + this.$route.params.id);
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    showMapIfNeeded() {

      if (this.map !== undefined || this.aufgabe.lat === 0.0 || this.aufgabe.lon === 0.0) {
        return;
      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        center: [this.aufgabe.lon, this.aufgabe.lat],
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

      this.marker = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    mapLoad() {
      setTimeout(() => {
        if (this.marker === null) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.aufgabe.lon, this.aufgabe.lat])
              .addTo(this.map);
        }
        this.map.resize();
        this.hideLoader()
      });
    },
  }
}
</script>

<style>

.icon-none {
  display: none !important;
}

.button-margin {
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 8px;
}

.marker {
  background-image: url('../../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.sc-message {
  width: 480px;
}

.sc-message--text .sc-message--toolbox {
  display: none;
}

.sc-launcher.opened :before {
  box-shadow: none;
}

.sc-launcher.opened:before {
  box-shadow: none !important;
}

.sc-chat-window {
  border: 1px solid lightgray !important;
  width: 520px !important;
  z-index: 5;
}

.sc-launcher {
  z-index: 5;
}

.sc-user-input {
  border-top: 1px solid lightgray !important;

}

.sc-user-input--text {
  width: 450px !important;
}

.sc-header--close-button {
  margin-left: 0 !important;
}

.my-body {
  padding: 0 !important;
}

.hidden_header {
  display: none;
}

.sc-user-input--file-icon-wrapper {
  margin-bottom: 0;
}
.sc-header {
  min-height: unset !important;
}

.tree-disabled>.tree-checkbox {
  display: none !important;
}

</style>

<style scoped>

.my-tree {
  max-height: calc(70vh - 70px);
  overflow: auto;
}

.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.p-center {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
}

.bold-text {
  font-weight: bold;
}

::placeholder { /* Firefox, Chrome, Opera */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}

</style>
